import { render } from "./EditSensor.vue?vue&type=template&id=5d4ad512&scoped=true&ts=true"
import script from "./EditSensor.vue?vue&type=script&lang=ts"
export * from "./EditSensor.vue?vue&type=script&lang=ts"

import "./EditSensor.vue?vue&type=style&index=0&id=5d4ad512&lang=scss&scoped=true"
import "./EditSensor.vue?vue&type=style&index=1&id=5d4ad512&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d4ad512"]])

export default __exports__